import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { DOCUMENT_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledTextField } from '../../../../../../components/ControlledTextField';
import { FieldLabel } from '../../../../../../components/Form';

const TextBlockchainAddressField = ({
  name = DOCUMENT_FILTER_FIELD_NAMES.BLOCKCHAIN_ADDRESS,
}) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage
          id="Document blockchain address"
          defaultMessage="Document blockchain address"
        />
      </FieldLabel>
      <ControlledTextField name={name} />
    </>
  );
};

export default TextBlockchainAddressField;
